import React, { lazy } from 'react';

import { dispatchChunkError } from 'components/NewVersionBar/NewVersionBar';

function isChunkLoadError(err: unknown): boolean {
  const message = err && typeof (err as { message?: string }).message === 'string'
    ? (err as { message: string }).message
    : '';
  const name = err && typeof (err as { name?: string }).name === 'string'
    ? (err as { name: string }).name
    : '';
  return (
    name === 'ChunkLoadError' ||
    message.includes('Loading chunk') ||
    message.includes('ChunkLoadError') ||
    message.includes('Loading CSS chunk') ||
    message.includes('missing') ||
    message.includes('(missing:') ||
    /chunk\.\w+\.chunk\.js/.test(message) ||
    /Failed to fetch dynamically imported module/.test(message)
  );
}

/**
 * Wraps React.lazy() to catch chunk load failures (e.g. after a new deployment
 * when the browser still has old JS pointing to old chunk URLs). On chunk error,
 * reloads the page once so the user gets the latest assets.
 * Uses ComponentType<any> so any route component (with specific props) is accepted.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithChunkReload<T extends React.ComponentType<any>>(
  importFn: () => Promise<{ default: T }>
): React.LazyExoticComponent<T> {
  return lazy(async (): Promise<{ default: T }> => {
    try {
      return await importFn();
    } catch (err) {
      if (typeof window !== 'undefined' && isChunkLoadError(err)) {
        dispatchChunkError();
        return new Promise<{ default: T }>(() => {});
      }
      throw err;
    }
  });
}
